
import { LeaseStepActionConst } from "../../constants/LeaseActionConst"
const initialState = {
    loader: false,
    allLease: [],
    leaseCreateStep: 1,
}
export default (state = initialState, action) => {
    switch (action.type) {
        case LeaseStepActionConst.LEASE_STEP_CHANGE:
            state = {
                ...state,
                leaseCreateStep: action.step
            }
            break
    }
    return state

}